module.exports = "//cdn.mxpnl.com/static/asset-cache/f03f133b493099b12954535f0c8b8c9a/iron/common/widgets/intro/images/profiles/brad-animated.gif";